const axios = require('axios')

export async function getClientIp () {
  return new Promise(async (resolve, reject) => {
    const response = await axios.get('https://api.ipify.org?format=json').catch(error => {
      console.error('Erro ao obter o IP:', error)
      reject(error)
    })
    resolve(response.data.ip)
  })
}



// WEBPACK FOOTER //
// ./src/utils/network.js